import { render, staticRenderFns } from "./UtilizationCards.vue?vue&type=template&id=95bd6644&scoped=true"
import script from "./UtilizationCards.vue?vue&type=script&lang=js"
export * from "./UtilizationCards.vue?vue&type=script&lang=js"
import style0 from "./UtilizationCards.vue?vue&type=style&index=0&id=95bd6644&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95bd6644",
  null
  
)

export default component.exports